// data/languages/wolof/illustrations.ts

export const categoryIllustrations = {
    'Salutations et expressions courantes': '👋',
    'Nombres': '🔢',
    'Temps': '📅',
    'Animaux': '🐘',
    'Famille et relations': '👨‍👩‍👧‍👦',
    'Nourriture et boissons': '🍽️',
    'Couleurs': '🎨',
    'Parties du corps': '🧑',
    'Verbes courants': '🏃‍♂️',
    'Grammaire': '📚'
  };

  export default categoryIllustrations ; 